module.exports = __webpack_public_path__ + "static/media/Joining_Kit_FORM.4dded423.pdf";